import * as cn from "classnames";
import * as React from "react";
import { loginUrl, currentUserTokenInfo, logoutUrl } from "@api/common";
import {
    AppState,
    ClientInterface,
    CustomerInterface,
    changeStatusCreateClientModalAction,
    isReportingOnlyCustomer,
    restartGuideAction
} from "@store";
import { connect, Dispatch } from "react-redux";
import { FETCH_STATE_SUCCESS, FetchingState } from "../../node_modules/rd-redux-http";
import { DashboardUrl, CampaignUrl, ReportUrl, UsersPageUrl } from "@common";
import { History, Location } from "history";
import { ModalWindow } from "./ModalWindow";
import { CreateClient } from "./CreateClientComponent";
import { SvgIcon } from "./SvgIcon";
import { Triangle } from "@icons";
import { LoadingSpinner } from "./LoadingSpinner";
import { LongNameOptionComponent } from "./LongNameOptionComponent";
import { Link } from "react-router-dom";

export interface CurrentUserInfoProps {
    customer: CustomerInterface;
    clientId: string;
    disableUsersLink: boolean;
    onRestartGuideTour: () => void;
}

interface CurrentUserInfoState {
    loginUrl: string | undefined;
    logoutUrl: string | undefined;
    isOpenLogout: boolean;
}

class CurrentUserInfo extends React.Component<CurrentUserInfoProps, CurrentUserInfoState> {
    constructor(props: CurrentUserInfoProps, context: any) {
        super(props, context);

        this.state = {
            loginUrl: undefined,
            logoutUrl: undefined,
            isOpenLogout: false
        };

        this.chageLogutDropdownState = this.chageLogutDropdownState.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    private myRef = React.createRef<HTMLDivElement>();

    componentWillMount() {
        loginUrl().then(url => this.setState({ loginUrl: url }));
        logoutUrl().then(url => this.setState({ logoutUrl: url }));
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick, false);
    }

    chageLogutDropdownState() {
        if (!this.state.isOpenLogout) {
            // attach/remove event handler
            document.addEventListener("click", this.handleOutsideClick, false);
        } else {
            document.removeEventListener("click", this.handleOutsideClick, false);
        }
        this.setState({
            ...this.state,
            isOpenLogout: !this.state.isOpenLogout
        });
    }

    handleOutsideClick(e: any) {
        const node = this.myRef.current;

        if (node && node.contains(e.target)) {
            return;
        }

        this.chageLogutDropdownState();
    }

    render() {
        const user = currentUserTokenInfo();
        const { clientId, disableUsersLink, onRestartGuideTour } = this.props;

        return user ? (
            <div className="user-block" ref={this.myRef}>
                <div className="user-select" onClick={() => this.chageLogutDropdownState()}>
                    {this.props.customer.name}
                    {this.props.customer.name && (
                        <SvgIcon className={cn("logout-icon", this.state.isOpenLogout ? "open" : "")} svg={Triangle} />
                    )}
                </div>
                <div className={cn("logout-block", this.state.isOpenLogout ? "open" : "")}>
                    <ul className="logout-block__list">
                        {!disableUsersLink && (
                            <li className="logout-block__list-item">
                                <Link className="logout-block__link" to={UsersPageUrl.format({ clientId: clientId })}>
                                    Users
                                </Link>
                            </li>
                        )}
                        <li className="logout-block__list-item" onClick={() => onRestartGuideTour()}>
                            <span className="logout-block__link">Guide</span>
                        </li>
                        {this.state.logoutUrl && (
                            <li className="logout-block__list-item logout-block__list-item_without-border">
                                <a className="logout-block__link" href={this.state.logoutUrl}>
                                    Logout
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        ) : (
            <a href={this.state.loginUrl}>Login</a>
        );
    }
}

export interface HeaderComponentProps {
    clients: ClientInterface[];
    clientId: string;
    className?: string;
    isEditCampaignPage: boolean;
    isMobileScreen: boolean;
    history?: History;
    location?: Location;
    customer: CustomerInterface;
    isOpenCreateClient: boolean;
    loadingClients: boolean;
    onlyReporting: boolean;
    selectClient: (clientId: string) => void;
    onChangeStatusCreateClientModal: (isOpen: boolean) => void;
    onRestartGuideTour: () => void;
}

export interface HeaderComponentState {
    isClientMenuOpen: boolean;
}

export class HeaderComponent extends React.Component<HeaderComponentProps, HeaderComponentState> {
    constructor(props: HeaderComponentProps) {
        super(props);
        this.state = {
            isClientMenuOpen: false
        };
    }

    async handleClientChange(e: any) {
        this.props.selectClient(e.target.value);
    }

    updateClientMenuState() {
        this.setState({ isClientMenuOpen: !this.state.isClientMenuOpen });
    }

    render() {
        const {
            clients,
            clientId,
            className,
            isEditCampaignPage,
            customer,
            isMobileScreen,
            onChangeStatusCreateClientModal,
            isOpenCreateClient,
            loadingClients,
            onlyReporting,
            onRestartGuideTour
        } = this.props;
        const { isClientMenuOpen } = this.state;

        const selectedClient = clients && clients.find(c => c.clientId === clientId);
        const canClientListRender =
            !loadingClients && clients && clientId && clients.length > 0 && clientId !== "direct";

        return (
            <header className={cn("header", className)}>
                {isMobileScreen && (
                    <div className="client-menu" onClick={() => this.updateClientMenuState()}>
                        <span>Client menu</span>
                    </div>
                )}
                <div className={cn("tool-bar", isClientMenuOpen ? "open" : "")}>
                    {loadingClients && <LoadingSpinner className="clients-spinner" />}
                    {canClientListRender && (
                        <div className="client-list-select-wrapper">
                            <select
                                name="client"
                                id="select-client"
                                value={clientId}
                                onChange={e => this.handleClientChange(e)}
                                title={selectedClient ? selectedClient.name : ""}
                            >
                                {!isEditCampaignPage &&
                                    clients &&
                                    clients.map((el: ClientInterface, index: number) => (
                                        <LongNameOptionComponent key={index} value={el.clientId} name={el.name} />
                                    ))}
                                {isEditCampaignPage &&
                                    clientId &&
                                    clients && (
                                        <LongNameOptionComponent
                                            value={clientId}
                                            name={selectedClient ? selectedClient.name : ""}
                                        />
                                    )}
                            </select>
                            {isEditCampaignPage ? (
                                ""
                            ) : (
                                <SvgIcon svg={Triangle} className={cn("client-list-select-triangle")} />
                            )}
                        </div>
                    )}
                    {clientId !== "direct" &&
                        !onlyReporting && (
                            <input
                                className="common-btn add-client-btn tour-common-add-client"
                                type="submit"
                                value="+ Add Client"
                                onClick={() => onChangeStatusCreateClientModal(true)}
                            />
                        )}
                </div>

                <div className="person tour-common-person">
                    <div className="person-info">
                        <CurrentUserInfo
                            customer={customer}
                            clientId={clientId}
                            disableUsersLink={onlyReporting}
                            onRestartGuideTour={onRestartGuideTour}
                        />
                    </div>
                </div>
                <ModalWindow modalId="createClientPopup" state={isOpenCreateClient} transition={true}>
                    <CreateClient />
                </ModalWindow>
            </header>
        );
    }
}

export interface HeaderProps {
    className?: string;
    isEditCampaignPage?: boolean;
    isMobileScreen?: boolean;
    clientId: string;
    history: History;
    location: Location;
}

export const Header = connect(
    (state: AppState, ownProps: HeaderProps): Partial<HeaderComponentProps> => {
        let clients: ClientInterface[];
        if (state.pagesState.clients.fetchState === FETCH_STATE_SUCCESS) {
            clients = (state.pagesState.clients.data.clients as any) as ClientInterface[];
        }

        const onlyReporting = isReportingOnlyCustomer(state);

        return {
            clients: clients as ClientInterface[],
            loadingClients: FetchingState.isFetching(state.pagesState.clients),
            clientId: ownProps.clientId,
            className: ownProps.className,
            isEditCampaignPage: ownProps.isEditCampaignPage,
            history: ownProps.history,
            location: ownProps.location,
            isOpenCreateClient: state.clientState.isOpenCreateClient,
            onlyReporting,
            customer:
                state.pagesState.customer.fetchState === FETCH_STATE_SUCCESS && state.pagesState.customer.data.customer
        };
    },
    (dispatch: Dispatch, ownProps: HeaderProps): Partial<HeaderComponentProps> => ({
        selectClient: (clientId: string) => {
            if (DashboardUrl.match(ownProps.location, true).isMatched) {
                ownProps.history.push(DashboardUrl.format({ clientId: clientId }));
                return;
            }
            if (CampaignUrl.match(ownProps.location, true).isMatched) {
                ownProps.history.push(CampaignUrl.format({ clientId: clientId }));
                return;
            }

            const reportPageMatch = ReportUrl.match(ownProps.location, true);
            if (reportPageMatch.isMatched) {
                ownProps.history.push(DashboardUrl.format({ clientId: clientId }));
                return;
            }
        },
        onChangeStatusCreateClientModal: (isOpen: boolean) => {
            dispatch(changeStatusCreateClientModalAction({ isOpen: isOpen }));
        },
        onRestartGuideTour: () => {
            dispatch(restartGuideAction());
        }
    })
)(HeaderComponent);
